module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0009.01e39f2c.png";